export const FETCH_CREATE_OWNER_REQUEST = 'FETCH_CREATE_OWNER_REQUEST'
export const FETCH_CREATE_OWNER_SUCCESS = 'FETCH_CREATE_OWNER_SUCCESS'
export const FETCH_CREATE_OWNER_FALUIRE = 'FETCH_CREATE_OWNER_FALUIRE'
